'use strict';

var sessionOutTimeStr = $('.session-expiry-time').val();
var sessionOutTime = parseInt(sessionOutTimeStr, 10);

// If the value is not a valid number, default to 90
if (isNaN(sessionOutTime)) {
    sessionOutTime = 90;
}
sessionOutTime = sessionOutTime * 60000; // eslint-disable-line
sessionOutTime = Math.trunc(sessionOutTime);

var sessionTimer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            this.id = null;
        }
    },
    start: function (duration, callback) {
        window.clearTimeout(this.id);
        this.id = setTimeout(callback, duration);
    }
};

var isSessionExpired = false;
var activeAjaxRequests = [];

$(document).ajaxSend(function (e, jqXHR) {
    activeAjaxRequests.push(jqXHR);
});

/**
 * Abort all ajax call after session expire.
 */
function abortAllAjax() {
    activeAjaxRequests.forEach(function (req) {
        if (req && req.readyState !== 4) {
            req.abort();
        }
    });
    activeAjaxRequests = [];
}

/**
 * Handles redirection to session timeout page.
 */
function sessionTimeoutPage() {
    var $pageName = $('.page');
    if ($pageName.data('page') === 'checkout') {
        var $checkoutMain = $('#checkout-main');
        if ($checkoutMain.data('customer-type') === 'registered') {
            var url = $checkoutMain.data('timeouturl');
            window.location.href = url;
        } else {
            window.location.reload();
        }
    }
    if ($pageName.data('page') === 'cart') {
        window.location.reload();
    }
}

/**
 * Detects session expiry.
 */
function sessionExpiry() {
    sessionTimer.start(sessionOutTime, function () {
        sessionTimer.clear();
        if (!isSessionExpired) {
            isSessionExpired = true;
            abortAllAjax();
        }
    });
}

$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    if (originalOptions.skipSessionCheck) return;

    if (isSessionExpired) {
        setTimeout(function () {
            sessionTimeoutPage();
        }, 0);
        jqXHR.abort();
        return;
    }
});

module.exports = sessionExpiry;
